import { Order, useOrderState } from 'entities/orders';
import { useMemo } from 'react';

import { TopButtonsContainerVariants } from 'widgets/orderDetail/ui/types';

interface UseOrderDetailHeaderParams {
	variant: TopButtonsContainerVariants;
	hasEdit: boolean;
}

export const useOrderDetailHeader = (
	order: Order,
): UseOrderDetailHeaderParams => {
	const {
		isVisitEnd,
		isVisitProgress,
		isVisitDelay,
		isCanceled,
		isVisitMissed,
	} = useOrderState(order);

	const hasEdit =
		!order.appointment?.dt_visit_end && !isCanceled && !isVisitMissed;

	const variant = useMemo(() => {
		if (isVisitEnd) {
			return 'default';
		}

		if (isVisitProgress) {
			return 'warning';
		}

		if (isVisitDelay) {
			return 'danger';
		}

		return 'default';
	}, [isVisitEnd, isVisitProgress, isVisitDelay]);

	return {
		variant,
		hasEdit,
	};
};
